/* TYPES */
export const TYPE_LOAD = "TYPE_LOAD";
export const TYPE_LOAD_SUCCESS = "TYPE_LOAD_SUCCESS";
export const TYPE_ERROR = "TYPE_ERROR";
export const TYPE_SAVE = "TYPE_SAVE";
export const TYPE_SAVE_SUCCESS = "TYPE_SAVE_SUCCESS";
export const TYPE_DELETE = "TYPE_DELETE";
export const TYPE_DELETE_SUCCESS = "TYPE_DELETE_SUCCESS";
export const TYPE_CLEAN = "TYPE_CLEAN";